// extracted by mini-css-extract-plugin
export var content = "reviews-module--content--HARyD";
export var header = "reviews-module--header--Tc+uV";
export var review = "reviews-module--review--loDZI";